// CANONICAL COPY (GH #7115). src/constants/obligations/obl-security-awareness.js re-exports this file so the browser and the
// Function App share one compliance engine — one definition of "compliant". Edit here, never there.
'use strict';

module.exports = {
  id: 'obl-security-awareness',
  title: 'Verify security awareness training is completed',
  description:
    'Confirm that all employees have completed security awareness training. Any of a verified training-completion evidence record (from the training module quiz), a verified training-attestation evidence record, the joiner JML security-training checkbox, or acknowledgement of the awareness materials satisfies this obligation.',
  category: 'people',
  scfIds: ['SCF-PPL-003'],
  cadence: { frequency: '1y', anchor: 'domain' },
  strategy: 'any',
  fulfilmentCriteria: [
    {
      type: 'training-completion-recorded',
      description:
        'Every active employee assigned to a training course has a verified, in-date completion record (quiz passed, auto-verified by server-side scoring, valid 1 year)',
    },
    {
      type: 'evidence-requirement-met',
      evidenceType: 'training-attestation',
      description: 'Verified, in-date training attestation for every employee in scope',
    },
    {
      type: 'employees-training',
      description: 'All employees have security-training completed in JML',
    },
    { type: 'document-acknowledged', description: 'Security awareness materials acknowledged' },
  ],
  domainActions: [
    { type: 'approve-document', label: 'Approve Document' },
    { type: 'deep-link', target: 'employees', label: 'Review Employee Records' },
  ],
};
